<template>
  <div class="introduction-page">
    <div class="container-fluid">
      <div class="row">
        <!-- Content -->
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              
              <div class="row">
                <div class="col-md-8 mx-auto">
                  <div class="mb-4">
                    <h3>{{ content.overview.title }}</h3>
                    <p>{{ content.overview.description }}</p>
                  </div>

                  <div class="mb-4">
                    <h3>{{ content.objectives.title }}</h3>
                    <ul>
                      <li v-for="objective in content.objectives.list" :key="objective">{{ objective }}</li>
                    </ul>
                  </div>

                  <div class="mb-4">
                    <h3>{{ content.reference.title }}</h3>
                    <p>{{ content.reference.description }}</p>
                    <a :href="content.reference.link" target="_blank" class="btn btn-primary btn-lg custom-apt-btn">
                      {{ content.reference.button }}
                    </a>
                  </div>

                  <div class="text-center mt-5">
                    <router-link to="/apt-map" class="btn btn-primary btn-lg custom-apt-btn">
                      {{ content.cta }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { languageStore } from '../stores/languageStore'

export default {
  name: 'Introduction',
  data() {
    return {
      content: {
        en: {
          title: 'Predictive Risk Identification & Strategy Model (PRISM)',
          overview: {
            title: 'Research Overview',
            description: 'PRISM is a research project that identifies and models behavioral traits of Advanced Persistent Threats (APTs) using criminological theories and the Big Five personality model. This integrative approach provides predictive insights into APT group behavior, facilitating decision-making and incident response strategies.'
          },
          objectives: {
            title: 'Research Objectives',
            list: [
              'Integrate classical criminological theories with APT analysis',
              'Apply the Big Five personality model to APT groups',
              'Develop predictive behavioral patterns for threat assessment',
              'Create practical frameworks for incident response optimization'
            ]
          },
          reference: {
            title: 'Full Research Article',
            description: 'For a comprehensive understanding of the PRISM methodology and detailed research findings, please refer to the complete academic publication.',
            link: 'https://www.researchgate.net/publication/390348186_Identification_and_modeling_of_behavioral_traits_of_Advanced_Persistent_Threats_APTs',
            button: 'Read Full Article'
          },
          cta: 'Explore APT Map'
        },
        es: {
          title: 'Modelo de Identificación de Riesgo Predictivo y Estrategia (PRISM)',
          overview: {
            title: 'Resumen de la Investigación',
            description: 'PRISM es un proyecto de investigación que identifica y modela rasgos de comportamiento de Amenazas Persistentes Avanzadas (APTs) utilizando teorías criminológicas y el modelo de personalidad de los Cinco Grandes. Este enfoque integrador proporciona perspectivas predictivas sobre el comportamiento de grupos APT, facilitando la toma de decisiones y estrategias de respuesta a incidentes.'
          },
          objectives: {
            title: 'Objetivos de la Investigación',
            list: [
              'Integrar teorías criminológicas clásicas con el análisis de APTs',
              'Aplicar el modelo de personalidad de los Cinco Grandes a grupos APT',
              'Desarrollar patrones de comportamiento predictivos para evaluación de amenazas',
              'Crear marcos prácticos para optimización de respuesta a incidentes'
            ]
          },
          reference: {
            title: 'Artículo Completo de Investigación',
            description: 'Para una comprensión integral de la metodología PRISM y los hallazgos detallados de la investigación, consulte la publicación académica completa.',
            link: 'https://www.researchgate.net/publication/390348186_Identification_and_modeling_of_behavioral_traits_of_Advanced_Persistent_Threats_APTs',
            button: 'Leer Artículo Completo'
          },
          cta: 'Explorar Mapa APT'
        }
      }
    }
  },
  computed: {
    language() {
      return languageStore.getLanguage()
    },
    content() {
      return this.content[this.language]
    }
  }
}
</script>

<style scoped>
.introduction-page {
  padding: 20px;
}

.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  border: none;
  background: var(--mm-custom-color-3);
  color: var(--mm-custom-color-5);
}

.card h1, .card h3, .card h5 {
  color: var(--mm-custom-color-2);
}

.card p, .card li {
  color: var(--mm-custom-color-5);
}

.btn-group .btn {
  min-width: 60px;
}

/* Dark theme enhancements */
.introduction-page {
  background: var(--mm-custom-color-1);
}

ul li {
  color: var(--mm-custom-color-5);
  margin-bottom: 8px;
}

.custom-apt-btn {
  background-color: transparent !important;
  border: 2px solid #DC780F !important;
  color: #DC780F !important;
  transition: all 0.3s ease;
}

.custom-apt-btn:hover {
  background-color: #DC780F !important;
  color: white !important;
}
</style>
